<template>
  <div>
    <add-new-file
      :dataToShow="stateAddFilePopup"
      @showChange="
        (val) => {
          changeStatePopupAddNewFile(val);
        }
      "
      @addTempFile="
        (data) => {
          addTempFile(data);
        }
      "
      @addFile="
        (infos) => {
          addFile(infos);
        }
      "
      :fileTemp="fileTemp"
      :errorMsg="errorsAddNewFile"
    />

    <add-member
      :data-to-show="isAddMemberPopupDisplayed"
      :folder="folderToShare"
      :errors="errorsAddMemberFolder"
      @showChange="
        (val) => {
          displayPopupAddMember(val);
        }
      "
      @addMembers="
        (members) => {
          addMembers(members);
        }
      "
      @editUserRights="
        (user, newRights) => {
          editUserRights(user, newRights);
        }
      "
      @editRoleRights="
        (role, newRights) => {
          editRoleRights(role, newRights);
        }
      "
      @revokeUserRights="
        (user) => {
          revokeUserRights(user);
        }
      "
      @revokeRoleRights="
        (role) => {
          revokeRoleRights(role);
        }
      "
    />

    <edit-file
      :data-to-show="isEditFilePopupDisplayed"
      :errors="errorsEditFile"
      :file="fileToEdit"
      @showChange="
        (val) => {
          displayPopupEditFile(val);
        }
      "
      @editFile="
        (fileEdited) => {
          editFile(fileEdited);
        }
      "
    />

    <delete-folder
      :data-to-show="isDeleteFolderPopupDisplayed"
      :errors="errorsDeleteFolder"
      :folder="folderToDelete"
      @close="displayPopupDeleteFolder(false)"
      @deleteFolder="deleteFolder()"
    />

    <preview-file
      :data-to-show="isPreviewPopupDisplayed"
      @close="displayPopupPreview(false)"
      :file="fileToDisplay"
    />

    <div class="px-12">
      <div v-if="files.length > 0" class="flex mb-8">
        <h4
          class="text-indigo-600 text-left cursor-pointer"
          @click="goToPath()"
        >
          Tous les fichiers
        </h4>
      </div>
      <add-button
        libelle="Ajouter un nouveau fichier"
        @add="changeStatePopupAddNewFile(1)"
        class="my-10"
      />
    </div>

    <div v-if="files.length > 0">
      <div
        class="grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 text-gray-600 text-lg items-center"
      >
        <div class="col-span-2 justify-self-center">Type</div>
        <div class="col-span-2">Nom du fichier</div>
        <div class="col-span-2">Dossier parent</div>
        <div class="col-span-2 justify-self-center">Membres</div>
        <div class="col-span-2">Date création</div>
        <div class="col-span-2 justify-self-center">Plus</div>
      </div>

      <div
        v-for="(file, numFile) in files"
        :key="numFile"
        class="grid grid-cols-12 gap-x-4 h-16 lg:h-24 2xl:h-32 text-base items-center odd:bg-gray-300 odd:bg-opacity-50"
      >
        <div class="col-span-2 justify-self-center">
          <tag
            :libelle="file.type.toUpperCase()"
            :themeColor="
              colorByType[file.type] ? colorByType[file.type] : 'default'
            "
          />
        </div>
        <div class="col-span-2">
          <info-bulle-hover
            :name="'filename' + file.id"
            :libelle="file.name.substring(0, file.name.lastIndexOf('.'))"
            :isDisplayTooltip="isFilenameTooltipDisplay == file.id"
            position="bottom-3 left-0"
          />
          <div
            class="truncate"
            @mouseover="isFilenameTooltipDisplay = file.id"
            @mouseleave="isFilenameTooltipDisplay = -1"
          >
            {{ file.name.substring(0, file.name.lastIndexOf('.')) }}
          </div>
        </div>
        <div class="col-span-2">
          <info-bulle-hover
            :name="'parent' + file.id"
            :libelle="
              file.folder_id == null
                ? 'Mon dépôt de documents'
                : folders.filter((f) => f.id == file.folder_id).length > 0
                ? folders.filter((f) => f.id == file.folder_id)[0].name
                : 'Mon dépôt de documents'
            "
            :isDisplayTooltip="isParentFolderNameTooltipDisplay == file.id"
            position="bottom-3 left-0"
          />
          <div
            class="truncate"
            @mouseover="isParentFolderNameTooltipDisplay = file.id"
            @mouseleave="isParentFolderNameTooltipDisplay = -1"
          >
            {{
              file.folder_id == null
                ? 'Mon dépôt de documents'
                : folders.filter((f) => f.id == file.folder_id).length > 0
                ? folders.filter((f) => f.id == file.folder_id)[0].name
                : 'Mon dépôt de documents'
            }}
          </div>
        </div>

        <list-avatars
          class="col-span-2 justify-self-center bottom-1/6"
          :list-items="file.users"
          libelle-firstname="firstname"
          libelle-lastname="lastname"
        />

        <div class="col-span-2">
          {{ new Date(file.created_at).toLocaleDateString() }}
        </div>
        <div class="col-span-2 justify-self-center">
          <div
            @click.stop="displaySubMenuFile(file.id)"
            class="cursor-pointer p-5"
          >
            <icon name="more-vertical" class="text-pink-600" />
            <div
              v-if="subMenuFileNumber == file.id"
              v-click-outside="hideSubMenuFile"
              class="absolute rounded-md bg-white shadow-lg shadow-gray-600 p-5 right-0 z-30"
            >
              <div class="flex flex-col space-y-2">
                <div
                  v-if="
                    constants.FILE_TYPES.img.includes(
                      file.type.toLowerCase()
                    ) ||
                    constants.FILE_TYPES.pdf.includes(file.type.toLowerCase())
                  "
                  @click="displayPopupPreview(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Visualiser
                </div>
                <div
                  v-if="
                    canEdit && $can(constants.PERMISSION_DEPOT_DOCUMENTS_MOVE)
                  "
                  @click="displayPopupMoveFile(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Déplacer
                </div>
                <div
                  v-if="
                    $adminFile(file, currentPage) &&
                    $can(constants.PERMISSION_DEPOT_DOCUMENTS_SHARE)
                  "
                  @click="displayPopupAddMember(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Partager
                </div>
                <div
                  @click="downloadAFile(file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Télécharger
                </div>
                <div
                  v-if="
                    $editFile(file, currentPage) &&
                    $can(constants.PERMISSION_DEPOT_DOCUMENTS_EDIT)
                  "
                  @click="displayPopupEditFile(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Éditer
                </div>
                <div
                  v-if="
                    $editFile(file, currentPage) &&
                    $can(constants.PERMISSION_DEPOT_DOCUMENTS_DELETE)
                  "
                  @click="displayPopupDeleteFolder(true, file)"
                  class="cursor-pointer text-gray-600 hover:text-gray-900"
                >
                  Supprimer
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import Illustration from './../../components/Illustration';
import AddButton from './../../components/Inputs/AddButton';
import Tag from './../../components/Tag';
import ListAvatars from './../../components/ListAvatars';
import Icon from './../../components/Icon';
import InfoBulleHover from './../../components/InfoBulleHover';

import AddNewFile from './popup/AddNewFile.vue';
import AddMember from './popup/AddMember';
import PreviewFile from './popup/PreviewFile.vue';
import EditFile from './popup/EditFile.vue';
import DeleteFolder from './popup/DeleteFolder.vue';

import Constants from './../../constants';
import ClickOutside from 'vue-click-outside';
import JsFileDownload from 'js-file-download';

export default {
  name: 'RecentsFiles',

  components: {
    Illustration,
    AddButton,
    Tag,
    ListAvatars,
    Icon,
    AddNewFile,
    AddMember,
    PreviewFile,
    EditFile,
    DeleteFolder,
    InfoBulleHover,
  },

  props: {
    files: {
      type: Array,
      required: true,
    },

    folders: {
      type: Array,
      required: true,
    },

    colorByType: {
      type: Object,
    },
  },

  data() {
    return {
      subMenuFileNumber: -1,

      isMoveFilePopupDisplayed: false,
      errorsMoveFile: {},
      fileToMove: {},

      isAddMemberPopupDisplayed: false,
      folderToShare: {},
      errorsAddMemberFolder: {},

      stateAddFilePopup: -1,
      fileTemp: {
        id: null,
        path: '',
        finalPath: '',
        name: '',
      },
      errorsAddNewFile: {},
      addNewFileLoading: false,

      isPreviewPopupDisplayed: false,
      fileToDisplay: {},

      isEditFilePopupDisplayed: false,
      errorsEditFile: {},
      fileToEdit: {},

      isDeleteFolderPopupDisplayed: false,
      folderToDelete: {},
      errorsDeleteFolder: {},

      constants: Constants,

      isFilenameTooltipDisplay: -1,
      isParentFolderNameTooltipDisplay: -1,
    };
  },

  mounted() {
    //
  },

  methods: {
    ...mapActions({
      moveTheFile: 'depotDocuments/moveTheFile',
      deleteCurrentFolder: 'depotDocuments/deleteCurrentFolder',
      shareFolderWithUsers: 'depotDocuments/shareFolderWithUsers',
      shareFolderWithRoles: 'depotDocuments/shareFolderWithMembers',
      editRightsUser: 'depotDocuments/editRightsUsers',
      editRightsRoles: 'depotDocuments/editRightsRoles',
      removeUsers: 'depotDocuments/removeUsers',
      removeRoles: 'depotDocuments/removeRoles',
      loadFiles: 'depotDocuments/loadFiles',
      addNewTempFile: 'depotDocuments/addNewTempFile',
      addNewFile: 'depotDocuments/addNewFile',
      downloadFile: 'depotDocuments/downloadFile',
      editCurrentFile: 'depotDocuments/editCurrentFile',
    }),

    ...mapMutations({
      setMessageHeader: 'depotDocuments/SET_MESSAGEHEADER',
    }),

    goToPath(path = null) {
      this.$emit('goto', path);
    },

    displayPopupEditFile(state, file = null) {
      if (file) {
        this.fileToEdit = { ...file };
      }
      this.isEditFilePopupDisplayed = state;
      this.errorsEditFile = {};
    },

    displayPopupDeleteFolder(state, folder = null) {
      if (folder) {
        this.folderToDelete = folder;
      }
      this.isDeleteFolderPopupDisplayed = state;
      this.errorsDeleteFolder = {};
    },

    displayPopupMoveFile(state, file = null) {
      if (file) {
        this.fileToMove = file;
      }
      this.isMoveFilePopupDisplayed = state;
      this.errorsMoveFile = {};
    },

    displayPopupAddMember(state, folder = null) {
      if (folder) {
        this.folderToShare = folder;
      }
      this.isAddMemberPopupDisplayed = state;
      this.errorsAddMemberFolder = {};
    },

    displayPopupPreview(state, file = null) {
      if (file) {
        this.fileToDisplay = { ...file };
      }
      this.isPreviewPopupDisplayed = state;
    },

    changeStatePopupAddNewFile(state) {
      this.stateAddFilePopup = state;
      this.errorsAddNewFile = {};
      this.addNewFileLoading = false;
    },

    displaySubMenuFile(fileId) {
      this.subMenuFileNumber = fileId;
    },

    hideSubMenuFile() {
      this.subMenuFileNumber = -1;
    },

    async editFile(file) {
      try {
        console.log('recent file file', file);
        await this.editCurrentFile([this.fileToEdit.id, file]).then(
          (response) => {
            this.isEditFilePopupDisplayed = false;
            this.errorsEditFile = {};
            this.fileToEdit = {};
          }
        );
      } catch (err) {
        this.errorsEditFile = err;
      }
    },

    async deleteFolder() {
      try {
        await this.deleteCurrentFolder(this.folderToDelete).then((response) => {
          this.isDeleteFolderPopupDisplayed = false;
          this.folderToDelete = {};
        });
      } catch (err) {
        this.errorsDeleteFolder = err;
      }
    },

    async moveFile(file) {
      try {
        await this.moveTheFile({
          source: this.fileToMove,
          destination: file,
        }).then((response) => {
          this.isMoveFilePopupDisplayed = false;
          this.fileToMove = {};
        });
      } catch (err) {
        this.errorsMoveFile = err;
      }
    },

    async downloadAFile(file) {
      try {
        await this.downloadFile(file).then((response) => {
          JsFileDownload(response.data, file.name);
        });
      } catch (err) {
        //
      }
    },

    async addMembers(members) {
      let responses = { users: 200, roles: 200 };
      if (members.users.length > 0) {
        try {
          responses.users = 0;
          await this.shareFolderWithUsers({
            folder: this.folderToShare,
            users: members.users,
          }).then((response) => {
            responses.users = response.status;
          });
        } catch (error) {
          console.error(error);
          this.errorsAddMemberFolder = error;
        }
      }

      if (members.roles.length > 0) {
        try {
          responses.roles = 0;
          await this.shareFolderWithRoles({
            folder: this.folderToShare,
            roles: members.roles,
          }).then((response) => {
            responses.roles = response.status;
          });
        } catch (error) {
          console.error(error);
          this.errorsAddMemberFolder = error;
        }
      }

      if (responses.users == 200 && responses.roles == 200) {
        let successMessage =
          this.folderToShare.type == 'folder'
            ? 'Le dossier a été partagé avec succès.'
            : 'Le fichier a été partagé avec succès.';
        this.setMessageHeader({ type: 'success', msg: successMessage });
        setTimeout(() => {
          this.setMessageHeader(null);
        }, 3000);
        await this.loadFiles().then((response) => {
          this.updateFolderToShare();
        });
      }
    },

    async editUserRights(user, newRights) {
      try {
        await this.editRightsUser({
          users: [user],
          newRights: newRights,
          folder: this.folderToShare,
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    async editRoleRights(role, newRights) {
      try {
        await this.editRightsRoles({
          roles: [role],
          newRights: newRights,
          folder: this.folderToShare,
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    async revokeUserRights(user) {
      try {
        await this.removeUsers({
          folder: this.folderToShare,
          users: [user],
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    async revokeRoleRights(role) {
      try {
        await this.removeRoles({
          folder: this.folderToShare,
          roles: [role],
        }).then((response) => {
          this.updateFolderToShare();
        });
      } catch (error) {
        console.error(error);
        this.errorsAddMemberFolder = error;
      }
    },

    updateFolderToShare() {
      this.folderToShare =
        this.folders.filter(
          (folder) => folder.id == this.folderToShare.id
        )[0] ||
        this.files.filter((file) => file.id == this.folderToShare.id)[0];
    },

    async addTempFile(data) {
      try {
        this.addNewFileLoading = true;
        await this.addNewTempFile(data).then((response) => {
          //the API returns the temporary path of the file
          this.fileTemp.path = response;
          this.fileTemp.finalPath = response.replace(
            'tmp/' + this.user.id + '/',
            ''
          );
          this.stateAddFilePopup = 2;
          this.addNewFileLoading = false;
        });
      } catch (err) {
        this.errorsAddNewFile = err;
        this.addNewFileLoading = false;
      }
    },

    async addFile(infos) {
      try {
        await this.addNewFile(infos).then((response) => {
          this.stateAddFilePopup = -1;
        });
      } catch (err) {
        this.errorsAddNewFile = err;
      }
    },
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    currentPage() {
      return this.$route.path;
    },

    canEdit() {
      let userId = this.currentPage.includes('/form/neopass/')
        ? parseInt(this.currentPage.split('/form/neopass/')[1].split('/')[0])
        : this.user.id;

      return (
        !this.currentPage.includes('/form/neopass/') ||
        this.$can('documents_edit', userId)
      );
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
